export const isNotFoundRoute = (url: string, options: { notFound?: boolean; isTenantDomain?: boolean }) => {
  const parts = url.split('?')[0].split('#')[0].split('/');
  parts.shift();

  // Page not found
  if (options.notFound || parts[0] === 'not-found') return true;
  return false;
};
